





























































import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { Client, GetFirmwareInfoResponse, FileTransferProgressEvent, IFileTransferProgressEvent, GetAllVersionsResponse, SoftwareVersion } from '@/common/apis/DeviceApi';
import UserMixin from '@/mixins/UserMixin';
import ApiProvider from '@/common/apis/ApiProvider';

@Component({
    components: {
    },
})
export default class SoftwareUpdateAvailableIcon extends Mixins(UserMixin) {
    public States = {
        Nothing: 'nothing',
        IsUpdating: 'is-updating',
        Updated: 'updated',
        Failed: 'failed',
    };

    @Prop({required: true})
    public deviceNumber: string;

    public state: string = this.States.Nothing;
    public softwareUpdateProgress: string = '';
    public error: string = '';
    public firmwareInfo: GetFirmwareInfoResponse | null = null;
    public versions: GetAllVersionsResponse | null = null;
    public version: string = '';

    public get progress(): number {
        return Math.round(this.getDeviceProgress(this.deviceNumber));
    }

    public get canClose(): boolean {
        return this.state === this.States.Nothing
            || this.state === this.States.Failed
            || this.state === this.States.Updated;
    }

    @Getter('devices/getDeviceProgress')
    private getDeviceProgress: (deviceNumber: string) => number;

    public async showModal() {
        (this.$refs['SoftwareUpdate' + this.deviceNumber] as any).show();
        const api = ApiProvider.getDeviceApi();
        this.versions = await api.getAllVersions(this.deviceNumber);
        if (this.versions.current) {
            this.version = this.versions.current.version || '';
        }
        this.state = this.States.Nothing;
        this.softwareUpdateProgress = '';
    }

    public get newUpdateAvailable(): boolean {
        if (this.firmwareInfo && this.firmwareInfo.currentVersion !== this.firmwareInfo.latestVersion) {
            return true;
        }
        return false;
    }
    public get titleText() {
        if (!this.firmwareInfo || !this.firmwareInfo.currentVersion || !this.firmwareInfo.latestVersion) {
            return '';
        }
        return this.$t('firmware-update.icon-title').toString()
            .replace('{current}', this.firmwareInfo.currentVersion)
            .replace('{new}', this.firmwareInfo.latestVersion);
    }
    public replaceTags(text: string): string {
        if (!this.firmwareInfo) {
            return text;
        }
        return text
            .replace(/\{currentVersion\}/g, this.firmwareInfo.currentVersion || '')
            .replace(/\{latestVersion\}/g, this.firmwareInfo.latestVersion || '')
            .replace(/\{deviceNumber\}/g, this.deviceNumber || '');
    }

    public getReleaseGroups(version: SoftwareVersion): string {
        const groups: string[] = [];
        if (version.releaseGroups) {
            if (version.releaseGroups.indexOf(0) > -1) {
                groups.push('Alfa');
            }
            if (version.releaseGroups.indexOf(1) > -1) {
                groups.push('Beta');
            }
            if (version.releaseGroups.indexOf(2) > -1) {
                groups.push('Public');
            }
        }
        return groups.join(', ');
    }

    public async mounted() {
        const api = ApiProvider.getDeviceApi();
        if (!this.isDeveloper) {
            this.firmwareInfo = await api.getFirmwareInfo(this.deviceNumber);
        }
    }

    public async updateNow() {
        this.$store.commit('devices/resetProgress', this.deviceNumber);
        Vue.set(this, 'state', this.States.IsUpdating);
        try {
            const api = ApiProvider.getDeviceApi();
            if (this.isDeveloper) {
                await api.updateToSpecificVersion(this.version, this.deviceNumber);
            } else {
                await api.updateToLatestVersion(this.deviceNumber);
            }
            Vue.set(this, 'state', this.States.Updated);

        } catch (e) {
            if (e.response && e.response.data && e.response.data.message) {
                this.error = e.response.data.message as string;
            } else {
                this.error = e;
            }
            Vue.set(this, 'state', this.States.Failed);
        }
    }
}

